import { render, staticRenderFns } from "./TradeRefferencesModal.vue?vue&type=template&id=f24375ea&scoped=true"
import script from "./TradeRefferencesModal.vue?vue&type=script&lang=js"
export * from "./TradeRefferencesModal.vue?vue&type=script&lang=js"
import style0 from "./TradeRefferencesModal.vue?vue&type=style&index=0&id=f24375ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24375ea",
  null
  
)

export default component.exports